const updateItemBy = (array, byField, values) =>
  array.map(item => {
    if (item[byField] !== values[byField]) return item;
    return { ...item, ...values };
  });

export default updateItemBy;
